import { atom } from "recoil";

export const doneButtonLoadingAtom = atom<boolean>({
  key: "doneButtonLoadingAtom",
  default: false,
});